(function (angular, app) {
    'use strict';

    app.service('BranchesService', [
        'Api',
        function (api) {
            var self = this;

            angular.extend(self, {
                getAreaTimes: getAreaTimes,
                getAreasDeliveryTimeTypes: getAreasDeliveryTimeTypes
            });

            function getAreaTimes(branchId, areaId) {
                return api.request({
                    method: 'GET',
                    url: '/v2/retailers/:rid/branches/' + (branchId || ':bid') + '/areas/' + areaId + '/delivery-times'
                }).then(function (resp) {
                    return resp;
                });
            }

            function getAreasDeliveryTimeTypes(retailerId, areaIds) {
                return api.request({
                    method: 'GET',
                    url: '/v2/retailers/' + retailerId + '/areas/delivery-time-types',
                    params: { areaId: areaIds }
                }).then(function (resp) {
                    if (resp && resp.areas) {
                        var deliveryTimeTypesByAreaIds = {};
                        angular.forEach(resp.areas, function (area) {
                            deliveryTimeTypesByAreaIds[area.id] = area.deliveryTimeTypes;
                        });
                        return deliveryTimeTypesByAreaIds;
                    }
                    return {};
                });
            }

        }]);

})(angular, app);